import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { LoadPagePanel } from '../../../../components';
import { useGetPurchaseOrder } from '../api/get-purchase-order';
import { RefetchScope, PurchaseOrderContext } from '../context/PurchaseOrderContext';
import { PurchaseOrderContextType } from '../types/PurchaseOrderContextType';


export default function PurchaseOrderPage(props: React.PropsWithChildren<unknown>) {

	const params = useParams();
	const purchaseOrderID = parseInt(params.purchaseOrderID!);

	const [orderState, setOrderState] = useState<PurchaseOrderContextType>({} as PurchaseOrderContextType);
	const { data, isLoading, refetch, isRefetching } = useGetPurchaseOrder(purchaseOrderID);
	const [refetchScope, setRefetchScope] = useState<RefetchScope | undefined>();

	// Clear context on order ID change 
	if (orderState.details && orderState.details.purchaseOrderID !== purchaseOrderID) {
		setOrderState({} as PurchaseOrderContextType);
	}

	useEffect(() => {
		if (data) {
			switch (refetchScope) {
				case RefetchScope.Files:
					setOrderState({
						details: { ...orderState.details, files: data.files }, originalDetails: data,
						modified: orderState.modified
					});
					break;

				case RefetchScope.Notes:
					setOrderState({
						details: { ...orderState.details, notes: data.notes }, originalDetails: data,
						modified: orderState.modified
					});
					break;

				default:
					setOrderState({ details: data, originalDetails: data, modified: false });
					break;
			}
		}
	}, [data]);

	return (
		<React.Fragment>
			{
				orderState.details &&
				<PurchaseOrderContext.Provider value={{
					order: orderState,
					modifyOrder: (details) => setOrderState(
						{ ...orderState, details: details, modified: true }),
					refetchOrder: (scope?: RefetchScope) => {
						setRefetchScope(scope);
						return refetch();
					}
				}}>

					<div className={'content-block order-page'}>
						{props.children}
					</div>
				</PurchaseOrderContext.Provider>
			}

			<LoadPagePanel visible={isLoading || isRefetching} />
		</React.Fragment>)
}
